import React, { useEffect } from 'react'
import { observer } from 'mobx-react-lite'
import { Routes, Route, useNavigate } from 'react-router-dom'
import { useStores } from '../../../cls/stores/MobXProvider'
import DocumentationLst from './DocumentationLst'
import { PageLoader } from '../../../components/Shared'
import {
	actLoadDocumentation,
	requireDocumentationById
} from '../../../stores/documentation/action'
import DocumentationEdit from './DocumentationEdit'
import { useSmartTranslation } from '../../../cls/TranslationContext'
/**
 * @component DocumentationMain
 * @description Main router and permissions gatekeeper for the Documentation section.
 * Loads appropriate sub-routes such as list view, edit form, and view-only form.
 * Handles route protection based on user authentication and authorization.
 */
const DocumentationMain = () => {
	const navigate = useNavigate()
	const { t } = useSmartTranslation()

	const { users } = useStores()
	const { loggedInUserId, loggedInUser } = users
	const isAdmin = loggedInUser?.isAdmin
	const isSuperAdmin = loggedInUser?.isSuperAdmin

	useEffect(() => {
		if (!users.isLoggedIn) {
			navigate('/logout')
			return
		}
	}, [loggedInUserId])

	// If the user does not have personal permission
	// and lacks the required permissions for the action and resource
	// Display a message indicating lack of permissions
	if (!(isAdmin || isSuperAdmin || users.canUser('read', 'documentation'))) {
		return (
			<div style={{ textAlign: 'center' }}>
				{t('__denied.access').charAt(0).toUpperCase() +
					t('__denied.access%__feature-off%_documentation')
						.toLowerCase()
						.slice(1)}
			</div>
		)
	}

	return (
		<Routes>
			<Route index element={<DocumentationLst />} />
			<Route
				path=":itmId/*"
				element={
					<PageLoader
						forceLoad={true}
						requireItm={(id) => {
							return requireDocumentationById(id)
						}}
						loadItm={(id) => actLoadDocumentation(id)}
						targetLst="documentation"
					/>
				}
			>
				<Route path="edit" element={<DocumentationEdit />} />
				<Route
					path="view"
					element={<DocumentationEdit viewOnly={true} />}
				/>
			</Route>
			<Route path="*" element={<div>Not found</div>} />
		</Routes>
	)
}
export default observer(DocumentationMain)
